import { all, takeLatest, put, call, fork, select } from "redux-saga/effects";
import { actions, constants } from "./actions";
import { apiV2 } from "../../services/api";

const { briefings: briefingsApi } = apiV2;
const { SUBMIT_BRIEFING_FORM, FETCH_BRIEFING_LIST, DELETE_BRIEFING } =
  constants;
const {
  submitBriefingForm,
  fetchBriefingList,
  deleteBriefing,
  updateBriefing,
  fetchBriefing,
} = actions;

// Action sagas - async
function* submitBriefingFormRequest() {
  yield takeLatest("SUBMIT_BRIEFING_FORM/REQUEST", function* ({ payload }) {
    try {
      const createBriefingOptions = { notes: payload.notes };
      yield call(briefingsApi.create, createBriefingOptions);
      yield put(
        submitBriefingForm.success({
          source: SUBMIT_BRIEFING_FORM,
          message: "Briefing successfully created.",
        })
      );
    } catch (err) {
      yield put(
        submitBriefingForm.failure({
          source: SUBMIT_BRIEFING_FORM,
          message: "Unable to create briefing, please try again.",
        })
      );
    }
  });
}

function* deleteBriefingRequest() {
  yield takeLatest("DELETE_BRIEFING/REQUEST", function* ({ payload }) {
    try {
      yield call(briefingsApi.delete, payload.id);
      yield put(
        deleteBriefing.success({
          source: DELETE_BRIEFING,
          message: "Briefing successfully deleted.",
          id: payload.id,
        })
      );
    } catch (err) {
      yield put(
        deleteBriefing.failure({
          source: DELETE_BRIEFING,
          message: "Unable to delete briefing, please try again.",
        })
      );
    }
  });
}

function* updateBriefingRequest() {
  yield takeLatest("UPDATE_BRIEFING/REQUEST", function* ({ payload }) {
    try {
      const briefingId = payload.id;
      const updateBriefingOptions = {
        updatedNotes: payload.notes,
      };
      yield call(briefingsApi.update, briefingId, updateBriefingOptions);
      yield put(
        updateBriefing.success({
          message: "Briefing successfully updated.",
        })
      );
    } catch (err) {
      yield put(
        updateBriefing.failure({
          message: "Unable to update briefing, please try again.",
        })
      );
    }
  });
}

function* fetchBriefingListRequest() {
  yield takeLatest("FETCH_BRIEFING_LIST/REQUEST", function* ({}) {
    try {
      let filters = {
        offset: yield select((state) => state.briefings.pageOffset),
        limit: yield select((state) => state.briefings.briefingsPerPage),
      };
      const searchQuery = yield select((state) => state.briefings.searchQuery);
      if (searchQuery) {
        filters.content = searchQuery;
      }
      const paginatedBreifings = yield call(briefingsApi.getAll, filters);
      yield put(
        fetchBriefingList.success({
          source: FETCH_BRIEFING_LIST,
          list: paginatedBreifings.data,
          total: paginatedBreifings.total,
          offset: paginatedBreifings.offset,
          limit: paginatedBreifings.limit,
          useNewApi: true,
        })
      );
      return;
    } catch (err) {
      yield put(
        fetchBriefingList.failure({
          source: FETCH_BRIEFING_LIST,
          message: "Unable to load briefings, please try again.",
        })
      );
    }
  });
}

function* fetchBriefingRequest() {
  yield takeLatest("FETCH_BRIEFING/REQUEST", function* ({ payload }) {
    try {
      const briefing = yield call(briefingsApi.getById, payload.id);
      yield put(fetchBriefing.success({ briefing }));
    } catch (err) {
      yield put(
        fetchBriefing.failure({
          message: "Unable to fetch briefing, please try again.",
        })
      );
    }
  });
}

// Watcher sagas
export default function* rootSaga() {
  yield all([
    fork(submitBriefingFormRequest),
    fork(fetchBriefingListRequest),
    fork(deleteBriefingRequest),
    fork(updateBriefingRequest),
    fork(fetchBriefingRequest),
  ]);
}
